import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ProfessionalXp from "./Missions/ProfessionalXp.jsx"
import Introduction from "./Missions/Introduction.jsx"
import withCurrentUniverse from "../../../HOC/withCurrentUniverse.jsx"

const PAGES = {
  FIRST: 'introduction',
  SECOND: 'professionalXp'
}
class MissionsStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      currentPage: PAGES.FIRST
    }
  }

  render() {
    return (this.state.currentPage === PAGES.FIRST)
      ? <Introduction
        currentUser={this.props.currentUser}
        freelance={this.props.freelance}
        submit={this.props.submit}
        nextPage={() => this.setState({currentPage: PAGES.SECOND})} />
      : <ProfessionalXp
        currentUser={this.props.currentUser}
        currentUniverse={this.props.currentUniverse}
        freelance={this.props.freelance}
        submit={this.props.submit}
        prevPage={() => this.setState({currentPage: PAGES.FIRST})} />
  }
}

export default withCurrentUniverse(MissionsStep)
